// removed by extract-text-webpack-plugin
module.exports = {"heroContainer":"_2Tz7_Q1mXEMtmMFOeChAC4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/css/style.css
// module id = 328
// module chunks = 0